import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (value: boolean) => void;
  /** Свёрнутые разделы меню: ключ — сайт и раздел. */
  folded: Record<string, boolean>;
  /** Разделы, раскрытые целиком («Ещё N»). */
  expanded: Record<string, boolean>;
  toggleFolded: (key: string) => void;
  toggleExpanded: (key: string) => void;
}

/**
 * Свёрнута ли боковая колонка.
 *
 * Запоминается в localStorage: это удобство конкретного человека на
 * конкретном устройстве, а не данные, и на сервере ему делать нечего.
 */
export const useSidebar = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => {
        set((state) => ({ collapsed: !state.collapsed }));
      },
      setCollapsed: (value) => {
        set({ collapsed: value });
      },
      folded: {},
      expanded: {},
      toggleFolded: (key) => {
        set((state) => ({ folded: { ...state.folded, [key]: state.folded[key] !== true } }));
      },
      toggleExpanded: (key) => {
        set((state) => ({ expanded: { ...state.expanded, [key]: state.expanded[key] !== true } }));
      },
    }),
    { name: 'faceta.sidebar' },
  ),
);
